import React, { useState } from "react";
import { Briefcase, MapPin, ArrowRight, CheckCircle2, Loader2 } from "lucide-react";
import PageShell, { PageHero } from "./PageShell";
import { careers } from "../content/pages";
import api from "../lib/api";

import { tr } from "../i18n";
export default function CareersPage() {
  const [selected, setSelected] = useState(careers.roles[0].title);
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/leads", {
        ...form,
        clientType: selected,
        mode: "careers",
      });
      setDone(true);
    } catch (err) {
      setError(tr("Could not submit your application. Please try again."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <PageShell>
      <PageHero eyebrow={careers.eyebrow} title={careers.title} intro={careers.intro} />
      <section className="bg-white py-16 md:py-24">
        <div className="max-w-5xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12">
          <div>
            <h2 className="font-display text-[28px] text-[#0b1f3a] mb-6">{tr("Open roles")}</h2>
            <div className="space-y-4">
              {careers.roles.map((r) => (
                <button
                  key={r.title}
                  onClick={() => setSelected(r.title)}
                  className={`w-full text-left rounded-2xl border p-6 transition-colors ${
                    selected === r.title
                      ? "border-[#c2a15a] bg-[#f6f2e9]/60"
                      : "border-[#0b1f3a]/8 hover:border-[#c2a15a]/40"
                  }`}
                >
                  <div className="flex items-center gap-2 text-[#0b1f3a]">
                    <Briefcase size={17} className="text-[#c2a15a]" />
                    <span className="font-display text-[20px]">{r.title}</span>
                  </div>
                  <p className="flex items-center gap-1.5 text-[13px] text-[#0b1f3a]/50 mt-1.5">
                    <MapPin size={13} /> {r.type}
                  </p>
                  <p className="text-[#0b1f3a]/60 text-[14px] mt-2">{r.body}</p>
                </button>
              ))}
            </div>
          </div>

          <div>
            <div className="rounded-2xl bg-[#0b1f3a] p-8 sticky top-28">
              {done ? (
                <div className="text-center py-8">
                  <div className="w-16 h-16 mx-auto rounded-full bg-white/10 flex items-center justify-center mb-4">
                    <CheckCircle2 size={32} className="text-[#c2a15a]" />
                  </div>
                  <h3 className="font-display text-white text-[24px]">{tr("Application received")}</h3>
                  <p className="text-white/60 mt-2">{tr("Thank you — our team will be in touch.")}</p>
                </div>
              ) : (
                <form onSubmit={submit} className="space-y-4">
                  <div>
                    <p className="text-[#c2a15a] text-[11px] tracking-[0.25em] uppercase mb-1">{tr("Apply for")}</p>
                    <p className="font-display text-white text-[22px]">{selected}</p>
                  </div>
                  <input required value={form.name} onChange={update("name")} placeholder={tr("Full name")} className="rh-input" />
                  <input required type="email" value={form.email} onChange={update("email")} placeholder={tr("Email")} className="rh-input" />
                  <input value={form.phone} onChange={update("phone")} placeholder={tr("Phone")} className="rh-input" />
                  <textarea value={form.message} onChange={update("message")} placeholder={tr("A short note about you")} rows={3} className="rh-input resize-none" />
                  {error && <p className="text-[13px] text-red-300">{error}</p>}
                  <button type="submit" disabled={busy} className="group w-full inline-flex items-center justify-center gap-2 bg-[#c2a15a] hover:bg-[#d8bd82] disabled:opacity-60 text-[#0b1f3a] font-semibold uppercase tracking-wide text-[14px] px-6 py-4 rounded-full transition-colors">
                    {busy ? <Loader2 size={18} className="animate-spin" /> : (<>{tr("Submit application")} <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" /></>)}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
